import { type Ref, ref, watchEffect } from 'vue'
import type { ObjectInventoryField } from '@/entities/Inventory/ObjectTypes'
import { useRoute } from 'vue-router'
import { useLoadTypePassportGridField } from './api.ts'

export const useModel = () => {
  const route = useRoute()

  const fieldList = ref<ObjectInventoryField[]>([])
  const inventoryType = ref<number | null>(null)

  const loadData = (objectType: number, open: Ref<boolean>) => {
    const result = useLoadTypePassportGridField(objectType, route.params.object_id as string, open)

    watchEffect(() => {
      if (result.data.value) {
        fieldList.value = result.data.value.data.fields
        inventoryType.value = result.data.value.data.id
      }
    })

    return result
  }

  return {
    fieldList,
    inventoryType,
    loadData,
  }
}
